export type ProductKeyTypes =
    | "confluence"
    | "confluence-PaidLpConflDocumentation"
    | "confluence-PaidLpConflFeatures"
    | "confluence-PaidLpConflTemplate"
    | "home"
    | "jiraServiceDesk"
    | "jiraServiceManagement"
    | "jiraSoftware"
    | "jiraSoftware-PaidLpJiraFeatures";

type CommonComponentsTypes = "linkButton" | "tab" | "card" | "carouselItem";

type CommonContainersTypes =
    | "navbarDropdown"
    | "navbar"
    | "globalNavWacDropdownContainer"
    | "heroSection"
    | "cardSection"
    | "ctaSection"
    | "announcementBanner"
    | "priceBlock"
    | "priceBlockDropdownLocalized";

type CommonEventTypes = "clicked" | "hovered" | "loading";

type JSWContainerTypes =
    | CommonContainersTypes
    | "featuresSection"
    | "benefitsSection"
    | "banner-link-button"
    | "pricingQuiz";

type JSMContainerTypes =
    | CommonContainersTypes
    | "integrationsSection"
    | "videoEmbedInline"
    | "linkButton"
    | "videoLink";

type ConfluenceContainerTypes =
    | CommonContainersTypes
    | "priceBlock"
    | "featuresSection"
    | "benefitsSection"
    | "additionalResourcesSection"
    | "videoEmbedInline"
    | "videoLink"
    | "integrationsSection"
    | "mobileSection"
    | "resourcesSection"
    | "templatesSection"
    | "templatesTabCard"
    | "testimonialsSection";

export type DataEventProps =
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "confluence"
              | "confluence-PaidLpConflDocumentation"
              | "confluence-PaidLpConflFeatures"
              | "confluence-PaidLpConflTemplate"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": ConfluenceContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              "home" | "jiraSoftware-PaidLpJiraFeatures"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": "jiraSoftware";
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSWContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceDesk">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceManagement">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      };
